import { Heading } from '@chakra-ui/react';
import CustomTabs from '@Modules/core/components/customTab/CustomTabs';
import PrintSettingDataTableHandler from '@Modules/terminalManagementSystem/gabManagement/containers/dataTableHandlers/globalSettings/printSetting/PrintSettingDataTableHandler';
import PrintSettingFormHandler from '@Modules/terminalManagementSystem/gabManagement/containers/formHandlers/globalSettings/printSetting/PrintSettingFormHandler';

import React from 'react';

const tabHeaders = ['Reçu', 'Journal'];

const PrintSettingTablePage = () => {
    const tabContents = React.useMemo(() => [<PrintSettingDataTableHandler tab='receipt' />, <PrintSettingDataTableHandler tab='diary' />], [])
  return (
    <>
        <Heading size="md" mb={"2rem"}>Configuration Impression</Heading>
        <PrintSettingFormHandler />
        <CustomTabs tabHeaders={tabHeaders} tabContents={tabContents} isLazy />
    </>
  )
}

export default PrintSettingTablePage